/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { type TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { TOAST_MESSAGE_CLEAR, TOAST_MESSAGE_HIDE, TOAST_MESSAGE_SHOW } from './toastmessage.types';

export type TToastMessageState = {
    isVisible: boolean;
    message: string;
};

export const toastMessageClearAction = (): TivoPayloadAction<
    Omit<TToastMessageState, 'isVisible'>
> => ({
    type: TOAST_MESSAGE_CLEAR,
    payload: {
        message: '',
    },
});

export const toastMessageHideAction = (): TivoPayloadAction<
    Omit<TToastMessageState, 'message'>
> => ({
    type: TOAST_MESSAGE_HIDE,
    payload: {
        isVisible: false,
    },
});

export const toastMessageShowAction = (message: string): TivoPayloadAction<TToastMessageState> => ({
    type: TOAST_MESSAGE_SHOW,
    payload: {
        isVisible: true,
        message,
    },
});
